import { render, staticRenderFns } from "./TabPet.vue?vue&type=template&id=6e5bd736&"
import script from "./TabPet.vue?vue&type=script&lang=js&"
export * from "./TabPet.vue?vue&type=script&lang=js&"
import style0 from "./TabPet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports